<template lang="pug">
  v-app
    v-card
      v-layout(wrap row class="pl-4")
        v-flex(xs12)
          v-select(label="Organisation" v-model="searchKunde" :items="kunden" item-value="id" item-text="firma" clearable)

        v-flex(xs12 sm6 md4 lg2)
          v-checkbox(v-if="kundenAbteilungen.length" hide-details label="Alle" @click.native="abteilungenSelectedToggle" :input-value="abteilungenSelectedAll" :indeterminate="abteilungenSelectedSome")
        v-flex(xs12 sm6 md4 lg2 v-for="abt in kundenAbteilungen" :key="abt.id")
          v-checkbox(hide-details v-model="abteilungenSelected" :value="abt.id" :label="abt.name")
      v-card-title
        | Projektliste
        v-spacer(class="hidden-xs-only")
        v-text-field(append-icon="search" label="Suche" single-line hide-details :value="$route.query['suche-projekt']" @input="$router.replace({ query: { \"suche-projekt\": $event } })")
        v-text-field(append-icon="search" label="Suche Mitarbeiter" single-line hide-details v-model="searchTelefonliste")
      div
        v-data-table(must-sort hide-actions no-data-text="keine daten" no-results-text="keine passenden daten" :items="filteredProjekte" :headers="headers" :loading="loading" :pagination.sync="pagination" :rows-per-page-items="[-1]")
          template(slot="items" slot-scope="props")
            tr(@click="props.expanded = !props.expanded")
              td {{ props.item.name_pnr }}
              td {{ props.item.abteilung }}
              td(v-if="$vuetify.breakpoint.mdAndUp").py-1: img.img-middle(v-if="props.item.logo" :src="props.item.logo")
          template(slot="expand" slot-scope="props")
            v-layout(row wrap)
              v-flex(xs12 md8)
                div(:class="$vuetify.breakpoint.mdAndUp ? 'embed-responsive embed-responsive-16by9' : ''")
                  div(:class="$vuetify.breakpoint.mdAndUp ? 'embed-responsive-item' : ''" :style="props.item.bild ? `background-size: cover; background-position: center; background-image: url(\"${props.item.bild}\");` : ''")
                    v-layout.white--text(pa-5 fill-height align-start column justify-end :style="`background-color: ${hexToRgba(props.item.bg_color || '#000', 85)};`")
                      div(style="width: 100%")
                        v-layout(row wrap)
                          v-flex(xs12 sm6 d-flex): v-layout(align-end): .bg-cirlcle: img(v-if="props.item.logo" :src="props.item.logo")
                          v-flex.text-sm-right(xs12 sm6 pt-2)
                            div(v-if="props.item.website"): a.white-link(:href="props.item.website") {{ props.item.website }}
                            div(v-if="props.item.email"): a.white-link(:href="`mailto://${props.item.email}`") {{ props.item.email }}
                            div(v-if="props.item.telefon") Tel: {{ props.item.telefon }}
                            div(v-if="props.item.fax") Fax: {{ props.item.fax }}
                            div(v-if="props.item.pnr") P-Nr: {{ props.item.pnr }}
                            div(v-if="props.item.standort && (props.item.standort.strasse || props.item.standort.hausnummer || props.item.standort.plz || props.item.standort.ort)")
                              | {{ props.item.standort.strasse }} {{ props.item.standort.hausnummer }}
                              br
                              | {{ props.item.standort.plz }} {{ props.item.standort.ort }}
                      .headline.pt-2 {{ props.item.name }}
                      .pt-2 {{ props.item.beschreibung }}
              v-flex(xs12 md4)
                div(:class="$vuetify.breakpoint.mdAndUp ? 'embed-responsive embed-responsive-16by18' : ''")
                  div(:class="$vuetify.breakpoint.mdAndUp ? `embed-responsive-item` : 'pl-5'" style="overflow-x: auto")
                    v-layout(column)
                      .px-3.py-2.striped-names(v-for="mitarbeiter in telefonliste.filter(t => t.projekt_ids.find(id => id === props.item.id))")
                        span.title {{mitarbeiter.titel}} {{mitarbeiter.vorname}} {{mitarbeiter.nachname}}
                        span(v-if="mitarbeiter.vorstand")  Vorstand
                        span(v-if="mitarbeiter.staebe_referenten")  Stäbe/Referenten
                        span(v-if="mitarbeiter.abteilungsleitung")  Abteilungsleitung
                        span(v-if="mitarbeiter.bereichsleitung")  Bereichsleitung
                        span(v-if="mitarbeiter.projektleitung")  Projektleitung
                        v-layout(wrap)
                          v-flex(style="width: 40px" v-if="mitarbeiter.thumb")
                            .user-thumb-round(:style="`background-image: url(${mitarbeiter.thumb})`")
                          v-flex
                            v-layout(wrap)
                              template(v-if="mitarbeiter.email")
                                v-flex.pr-2(xs12 sm3 text-md-right) E-Mail:
                                v-flex(xs12 sm9) {{mitarbeiter.email}}
                              template(v-if="mitarbeiter.telefon")
                                v-flex.pr-2(xs12 sm3 text-md-right) Tel:
                                v-flex(xs12 sm9) {{mitarbeiter.telefon}}
                              template(v-if="mitarbeiter.fax")
                                v-flex.pr-2(xs12 sm3 text-md-right) Fax:
                                v-flex(xs12 sm9) {{mitarbeiter.fax}}
        
        .d-flexx
          v-spacer
          v-menu.mr-5(top offset-y open-on-hover)
              v-btn(slot="activator" icon)
                v-icon vertical_align_bottom
              v-list
                v-list-tile(@click="downloadClipboard"): v-list-tile-title In Zwischenablage Kopieren

</template>

<style lang="stylus" scoped>
.datatable 
  tr
    &:nth-child(4n-1)
      background-color #f4f4f4
.striped-names:nth-child(2n)
  background-color #f4f4f4
.bg-cirlcle
  background-color white
  display inline-block
  border-radius 5px
  padding 5px
  > img
    vertical-align middle
.img-middle
  vertical-align middle
.white-link
  color white
  text-decoration none
.user-thumb-round
  border-radius 50%
  width 40px
  height 40px
</style>

<script>
import hexToRgba from 'hex-rgba';
import { writeText } from 'clipboard-polyfill'
import { sortBy, uniqBy } from 'lodash'

function findBy(key, valueToFind) {
  return function(item) {
    return item[key] === valueToFind
  }
}
function sortByX(key) {
  return function(a, b) {
    if (a[key] > b[key]) {
      return 1
    } else if (a[key] < b[key]) {
      return -1
    } else {
      return 0
    }
  }
}
function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}
function uniq(array) {
  return array.filter(onlyUnique)
}
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
function mapProjectId(id) {
  return this.projekte.find(findBy('id', id)) || { id: id }
}

export default {
  name: 'extra-projektliste',
  data() {
    Promise.all([
      this.$http.get('/api/v1b/telefonliste?q[status_eq]=angestellt&q[art_eq]=mitarbeiter').then(r => r.json()),
      this.$http.get('/api/v1b/projekte').then(r => r.json())
    ]).then(([telefonliste, projekte]) => {
      this.projekte = projekte.sort(sortByX('name_pnr'))
      this.projekte.forEach(projekt => {
        projekt.kundeId = projekt.standort && projekt.standort.kunde && projekt.standort.kunde.id || 'none'
        projekt.abteilung = projekt.abteilung || 'Keine'
      })
      telefonliste = telefonliste.sort(sortByX('vorname'))
      var abteilungen = uniq(projekte.map(p => p.abteilung || 'Keine')).sort().map(a => { return { name: a, id: a } })
      var kunden = sortBy(uniqBy(projekte.map(p => p.standort && p.standort.kunde || { firma: "Keine", id: 'none' }), 'id'), 'firma') //.map(k => { return { name: k.firma, value: k.id } })
      telefonliste.forEach( (person) => {
        person.projekte = person.projekt_ids.map(mapProjectId, this)
        person.abteilungen = uniq(person.projekte.map(p => p.abteilung)).sort()
        person.abteilungen.forEach(a => {
          if (a && ! abteilungen.find(aa => a === aa.id)) {
            abteilungen.push({ name: a, id: a })
          }
        })
      })
      this.abteilungen = abteilungen
      this.telefonliste = telefonliste
      this.kunden = kunden
      this.abteilungenSelected = this.abteilungen.map(a => a.id)
    }).finally(_ => {
      this.loading = false
    });
    return {
      pagination: { sortBy: 'abteilung', descending: false },
      projekte: [],
      telefonliste: [],
      abteilungen: [],
      searchKunde: 1,
      kunden: [],
      abteilungenSelected: [],
      searchTelefonliste: '',
      loading: true
    };
  },
  computed: {
    headers() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return [
          { text: 'Name', value: 'name' },
          { text: 'Abteilung', value: 'abteilung' }
        ]
      } else {
        return [
          { text: 'Name', value: 'name' },
          { text: 'Abteilung', value: 'abteilung' },
          { text: 'Logo', sortable: false }
        ]
      }
    },
    filteredTelefonliste() {
      var telefonliste = this.telefonliste

      if (this.abteilungenSelected) {
        var abteilungen = this.abteilungenSelected
        telefonliste = telefonliste.filter(tel => tel.projekte.length === 0 || tel.projekte.find(p => abteilungen.find(a => p.abteilung === a)))
      }

      if (this.searchTelefonliste) {
        var parts = this.searchTelefonliste.split(/\s+/).filter(p => p).map(p => new RegExp(escapeRegExp(p), 'i'))
        var filter = function(t) {
          var fields = [t.vorname, t.nachname, t.email, t.telefon, t.fax]
          return parts.every(p => fields.find(f => f && p.test(f)))
        }
        telefonliste = telefonliste.filter(filter)
      }

      return telefonliste
    },
    filteredTelefonlisteProjekte() {
      var projekt_ids = []
      this.filteredTelefonliste.forEach(t => {
        t.projekt_ids.forEach(id => {
          if (projekt_ids.indexOf(id) < 0) {
            projekt_ids.push(id)
          }
        })
      })
      return projekt_ids
    },
    kundenProjekte() {
      var projekte = this.projekte
      if (this.searchKunde) {
        var kundeId = this.searchKunde
        projekte = projekte.filter(p => p.kundeId == kundeId)
      }
      return projekte
    },
    kundenAbteilungen() {
      return uniq(this.kundenProjekte.map(p => p.abteilung || 'Keine')).sort().map(a => { return { name: a, id: a } })
    },
    filteredProjekte() {
      var projekte = this.kundenProjekte

      if (this.abteilungenSelected) {
        var abteilungen = this.abteilungenSelected
        projekte = projekte.filter(p => abteilungen.find(a => p.abteilung === a))
      }

      const search = this.$route.query['suche-projekt']
      if (search) {
        var parts = search.split(/\s+/).filter(p => p).map(p => new RegExp(escapeRegExp(p), 'i'))
        var filter = function(t) {
          var fields = [t.name_pnr]
          return parts.every(p => fields.find(f => f && p.test(f)))
        }
        projekte = projekte.filter(filter)
      }

      if (this.searchTelefonliste) {
        var filteredTelefonlisteProjekte = this.filteredTelefonlisteProjekte
        projekte = projekte.filter(p => filteredTelefonlisteProjekte.indexOf(p.id) >= 0)
      }

      return projekte
    },
    projekteByAbteilung() {
      var projekteByAbteilung = this.abteilungen.reduce((all, a) => {
        all[a.id] = []
        return all
      }, {})

      this.projekte.forEach(p => projekteByAbteilung[p.abteilung].push(p))

      return projekteByAbteilung
    },
    abteilungenSelectedAll() {
      return this.abteilungenSelected.length === this.abteilungen.length
    },
    abteilungenSelectedSome() {
      return this.abteilungenSelected.length > 0 && ! this.abteilungenSelectedAll
    }
  },
  watch: {
  },
  methods: {
    hexToRgba,
    abteilungenSelectedToggle() {
      if (this.abteilungenSelected.length)  {
        this.abteilungenSelected = []
      } else {
        this.abteilungenSelected = this.abteilungen.map(a => a.id)
      }
    },
    downloadClipboard() {
      writeText(this.filteredProjekte.filter(p => p.email).map(p => p.email).join("; "))
    },
  }
}
</script>
